export const productionProductMapping: { [key: string]: string } = {
  geweldigeglinsteringgrijsbruinzwartvilt: "6544da2ab853a202000d42db",
  geweldigeglinsteringmokkazwartvilt: "6544da9ab853a202000d42ee",
  geweldigeglinsteringbronszwartvilt: "6544db6fb853a202000d4317",
  geweldigeglinsteringgoudzwartvilt: "6544dbf0b853a202000d432f",
  geweldigeglinsteringkoperzwartvilt: "6544ddc6b853a202000d4374",
  machtigmetallicchampagnezwartvilt: "6544e55db853a202000d440c",
  machtigmetallicchampagnebeigevilt: "6544e59976149802005eaf4f",
  machtigmetallicparelmoerbeigevilt: "6544e6179f30d40200cf4d28",
  machtigmetalliczwartzwartvilt: "6544e67976149802005eaf78",
  machtigmetallicdonkergroenzwartvilt: "6544e6c4b853a202000d442d",
  machtigmetallictaupezwartvilt: "6544e70076149802005eaf9b",
  magnifiekmatflessengroenzwartvilt: "6544e75cb853a202000d443a",
  magnifiekmatlichtblauwzwartvilt: "6544e7acb853a202000d444a",
  magnifiekmatlichtblauwbeigevilt: "6544e7f4b853a202000d4452",
  magnifiekmatbeigezwartvilt: "6544e84676149802005eafd9",
  magnifiekmatbeigebeigevilt: "6544e89576149802005eafec",
  magnifiekmatroomwitbeigevilt: "6544e91c76149802005eaff8",
  magnifiekmatcamouflagegroenzwartvilt: "6544e98976149802005eb00a",
  magnifiekmatcamouflagegroenbeigevilt: "6544e9c0b853a202000d4472",
  magnifiekmatrozebeigevilt: "6544ea0a76149802005eb01f",
  magnifiekmatlilazwartvilt: "6544ea40b853a202000d4486",
  magnifiekmatlilabeigevilt: "6544ea8b76149802005eb02b",
  magnifiekmatoudrozezwartvilt: "6544eadd76149802005eb039",
  magnifiekmatoudrozebeigevilt: "6544eb889f30d40200cf4d45",
  magnifiekmatdonkerroodzwartvilt: "6544ebbdb853a202000d44a2",
  zenenzachtivoorbeigevilt: "6544ecf776149802005eb068",
  zenenzachtbeigebeigevilt: "6544ed3fb853a202000d44c7",
  zenenzachttaupezwartvilt: "6544edb976149802005eb081",
  zenenzachttaupebeigevilt: "6544ee1276149802005eb08e",
  zenenzachtlichtgroenzwartvilt: "6544ee5bb853a202000d44da",
  zenenzachtlichtgroenbeigevilt: "6544eeda76149802005eb09e",
  zenenzachtgrijsgroenzwartvilt: "6544ef54b853a202000d44e4",
  zenenzachtgrijsgroenbeigevilt: "6544ef9876149802005eb0ac",
  zenenzachtzalmbeigevilt: "6544efd3b853a202000d44e9",
  zenenzachtterracottazwartvilt: "6544f0169f30d40200cf4d58",
  subliemsuedegrijsblauwzwartvilt: "6544f274e2b4a00200900f42",
  subliemsuedewijnroodzwartvilt: "6544f2b1b853a202000d4516",
  subliemsuedemuisgrijszwartvilt: "6544f2e5e2b4a00200900f4b",
  subliemsuedechocoladebruinzwartvilt: "6544f321e2b4a00200900f57",
  subliemsuedebeigebruinzwartvilt: "6544f354e2b4a00200900f63",
  volledigviltzwartvilt: "65783a08d32c7a02007646e2",
  volledigviltbeigevilt: "65783a4a9597e70200925568",
  hoogwaardighoutblankeikenmetzwartvilt: "657acc857cc1680200a9310f",
  hoogwaardighoutblankeikenmetbeigevilt: "657acd057cc1680200a9311c",
  subliemsuedeoudrozezwartvilt: "65ddba1dc1dbe30200cb7848",
  subliemsuedelichtwarmgrijszwartvilt: "65ddbbe0c1dbe30200cb786c",
  subliemsuedelichtwarmgrijsbeigevilt: "65ddbc3fc1dbe30200cb7875",
  subliemsuedemuisgrijszwartvilt2: "65ddbcabc1dbe30200cb788b",
  subliemsuedezandzwartvilt: "65ddbd0cc1dbe30200cb7896",
  subliemsuedezandbeigevilt: "65ddbd6c05df9a02007985f2",
  subliemsuedeoudrozebeigevilt: "65fc0fd3d585a30200860b40",
  geweldigeglinsteringgrijsbruinmetbeigevilt: "6628f562cfb9e502007f0087",
  geweldigeglinsteringmokkametbeigevilt: "6628f5b7540a6602006e54ae",
  geweldigeglinsteringbronsmetbeigevilt: "6628f64d540a6602006e54c1",
  geweldigeglinsteringgoudmetbeigevilt: "6628f80128ed0c0200077da8",
  geweldigeglinsteringkopermetbeigevilt: "6628f84a28ed0c0200077db5",
  machtigmetallicparelmoermetzwartvilt: "6628f88f28ed0c0200077dbc",
  machtigmetalliczwartmetbeigevilt: "6628f8c807741f02004a5dd7",
  machtigmetallicdonkergroenmetbeigevilt: "6628f90307741f02004a5de0",
  machtigmetallictaupemetbeigevilt: "6628f94107741f02004a5ded",
  subliemsuedemuisgrijsmetbeigevilt: "6628f980540a6602006e5500",
  zenenzachtivoormetzwartvilt: "6628f9e3540a6602006e5510",
  zenenzachtbeigemetzwartvilt: "6628fa3c07741f02004a5e02",
  zenenzachtzalmmetzwartvilt: "6628fa9b540a6602006e5525",
  zenenzachtterracottametbeigevilt: "6628fad3540a6602006e552a",
  vgroefzwart: "669e009667bffc0002c272d5",
  vgroefbeige: "669e014267bffc0002c272ea",
  eindprofielgitzwart: "669761b3d7356a00026bb098",
  eindprofielgrijsblauw: "669761edd7356a00026bb0a7",
  eindprofielolijf: "6697622fd7356a00026bb0b8",
  eindprofielkiezelgrijs: "66976276d7356a00026bb0c2",
  eindprofielvenstergrijs: "669762c0d7356a00026bb0d4",
  eindprofielgrijsbruin: "669762fc5449800002990318",
  eindprofielzuiverwit: "6697636dd7356a00026bb0f3",
  eindprofielzwartgrijs: "669763abd7356a00026bb0ff",
  eindprofielmahonie: "669763e1d7356a00026bb108",
  eindprofielleem: "66976410d7356a00026bb10e",
  eindprofielgoud: "6697644bd7356a00026bb11c",
  eindprofielbrons: "66976485d7356a00026bb122",
  eindprofielbeige: "669764c1d7356a00026bb129",
  eindprofielparelwit: "673dc0ec37581d0002738048",
  eindprofieltaupe: "673dc2af37581d0002738081",
  eindprofielgrijsbeige: "673dc3a4472507000286f079",
  duinenbronsdonkerbruin: "68a4459b7889b30002f5de23",
  duinengrijsblauwgrijsblauw: "68a446357889b30002f5de30",
  duinenbeigebeige: "68a44baaa679d00002fec5c1",
  duinenzandsteendonkerbeige: "68a44c5a7889b30002f5ded0",
  gewevengrijsblauwgrijsblauw: "689b42ad1985b100024a31a5",
  gewevenbronsdonkerbruin: "689b42b41985b100024a31ac",
  gewevenivoorbeige: "689b42bb1985b100024a31b2",
  geweventaupedonkerbeige: "689b42c11985b100024a31b8",
  houtnerfijsblauwbeige: "689b42c79a344f0002da2bde",
  houtnerflichtbruindonkerbeige: "689b42cd1985b100024a31c3",
  houtnerfroodbruindonkerbeige: "689b42d31985b100024a31c9",
  houtnerfdonkerbruindonkerbruin: "689b42d91985b100024a31d3",
  houtnerfijsblauwgrijsblauw: "689b42e01985b100024a31d9",
  houtnerflichtbruindonkerbruin: "689b42e61985b100024a31df",
  houtnerfroodbruinzwart: "689b42ec1985b100024a31e4",
  houtnerfdonkerbruinzwart: "689b42f21985b100024a31e8",
  linnenoudrozedonkerbeige: "689b42f89a344f0002da2be3",
  linnenkiezelbeige: "689b42fe1985b100024a31f2",
  linnenlichtgrijsgrijsblauw: "689b43041985b100024a31f8",
  linnenlichtbruindonkerbruin: "689b430a1985b100024a31fe",
  vgroefdonkerbruin: "689b43101985b100024a3204",
  vgroefgrijsblauw: "689b43171985b100024a3209",
  vgroefdonkerbeige: "689b431fed964800029d2000",
  volledigviltcdonkerbruin: "689b43251985b100024a3210",
  volledigviltgrijsblauw: "689b432c1985b100024a3216",
  volledigviltdonkerbeige: "689b43329a344f0002da2beb",
};

export const developmentProductMapping: { [key: string]: string } = {
  zenenzachtlichtgroenbeigevilt: "6544eeda76149802005eb09e",
  zenenzachtlichtgroenzwartvilt: "6544ee5bb853a202000d44da",
  volledigviltbeigevilt: "65783a4a9597e70200925568",
  volledigviltzwartvilt: "65783a08d32c7a02007646e2",
  vgroefbeige: "669e014267bffc0002c272ea",
  vgroefzwart: "669e009667bffc0002c272d5",
  zenenzachttaupebeigevilt: "6544ee1276149802005eb08e",
  zenenzachttaupezwartvilt: "6544edb976149802005eb081",
  zenenzachtzalmbeigevilt: "6544efd3b853a202000d44e9",
  zenenzachtzalmmetzwartvilt: "6628fa9b540a6602006e5525",
  zenenzachtivoorbeigevilt: "6544ecf776149802005eb068",
  zenenzachtivoormetzwartvilt: "6628f9e3540a6602006e5510",
  zenenzachtbeigebeigevilt: "6544ed3fb853a202000d44c7",
  zenenzachtbeigemetzwartvilt: "6628fa3c07741f02004a5e02",
  zenenzachtgrijsgroenbeigevilt: "6544ef9876149802005eb0ac",
  zenenzachtgrijsgroenzwartvilt: "6544ef54b853a202000d44e4",
  zenenzachtterracottametbeigevilt: "6628fad3540a6602006e552a",
  zenenzachtterracottazwartvilt: "6544f0169f30d40200cf4d58",
  geweldigeglinsteringbronszwartvilt: "6544db6fb853a202000d4317",
  geweldigeglinsteringbronsmetbeigevilt: "6628f64d540a6602006e54c1",
  geweldigeglinsteringgrijsbruinzwartvilt: "6544da2ab853a202000d42db",
  geweldigeglinsteringgrijsbruinmetbeigevilt: "6628f562cfb9e502007f0087",
  geweldigeglinsteringgoudzwartvilt: "6544dbf0b853a202000d432f",
  geweldigeglinsteringgoudmetbeigevilt: "6628f80128ed0c0200077da8",
  geweldigeglinsteringkoperzwartvilt: "6544ddc6b853a202000d4374",
  geweldigeglinsteringkopermetbeigevilt: "6628f84a28ed0c0200077db5",
  geweldigeglinsteringmokkazwartvilt: "6544da9ab853a202000d42ee",
  geweldigeglinsteringmokkametbeigevilt: "6628f5b7540a6602006e54ae",
  machtigmetallicdonkergroenzwartvilt: "6544e6c4b853a202000d442d",
  machtigmetallicdonkergroenmetbeigevilt: "6628f90307741f02004a5de0",
  machtigmetalliczwartzwartvilt: "6544e67976149802005eaf78",
  machtigmetalliczwartmetbeigevilt: "6628f8c807741f02004a5dd7",
  machtigmetallicparelmoermetzwartvilt: "6628f88f28ed0c0200077dbc",
  machtigmetallicparelmoerbeigevilt: "6544e6179f30d40200cf4d28",
  machtigmetallicchampagnezwartvilt: "6544e55db853a202000d440c",
  machtigmetallicchampagnebeigevilt: "6544e59976149802005eaf4f",
  machtigmetallictaupezwartvilt: "6544e70076149802005eaf9b",
  machtigmetallictaupemetbeigevilt: "6628f94107741f02004a5ded",
  eindprofielral9010: "6697636dd7356a00026bb0f3",
  eindprofielral9005: "669761b3d7356a00026bb098",
  eindprofielzwartgrijs: "669763abd7356a00026bb0ff",
  eindprofielbeige: "669764c1d7356a00026bb129",
  eindprofielgoud: "6697644bd7356a00026bb11c",
  eindprofielmahonie: "669763e1d7356a00026bb108",
  eindprofielleem: "66976410d7356a00026bb10e",
  eindprofielolijf: "6697622fd7356a00026bb0b8",
  eindprofielkiezelgrijs: "66976276d7356a00026bb0c2",
  eindprofielvenstergrijs: "669762fc5449800002990318",
  eindprofieldonkerbrons: "673dc23737581d0002738071",
  eindprofielgrijsbeige: "673dc3a4472507000286f079",
  eindprofieltaupe: "673dc2af37581d0002738081",
  eindprofielparelwit: "673dc0ec37581d0002738048",
  eindprofielgrijsblauw: "669761edd7356a00026bb0a7",
  eindprofielgrijsbruin: "669762fc5449800002990318",
};
